import { FormControl } from 'baseui/form-control'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import getError from '@/containers/SubscriptionFormPageNew/getError'
import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import IconWarning from '@/shared/icons/NewDesign/IconWarning'

const ElectricCarDistance = () => {
  const { t, energyLandscape, updateAddressEnergyLandscape, errors } = useAddress()

  const { electricCar, electricCarDistance } = energyLandscape

  if (!electricCar) {
    return null
  }

  return (
    <>
      <FormControl error={getError('electricCarDistance', errors)}>
        <SDInput
          label={t('subscriptionTools:estimator.equipment.electric_car_distance')}
          onBlur={value => {
            const filteredOnlyNumberValue = value?.replace(/[^0-9]/g, '')
            updateAddressEnergyLandscape({
              electricCarDistance: filteredOnlyNumberValue || null,
            })
          }}
          currentValue={electricCarDistance}
          endEnhancer={t('common:km_by_year')}
        />
      </FormControl>
      <div
        style={{
          display: 'flex',
          marginBottom: '1rem',
          padding: '.5rem',
          gap: '.5rem',
          borderRadius: '.5rem',
          border: '1px dashed #D2A604',
          backgroundColor: '#FFEBC3',
        }}
      >
        <IconWarning size={24} color='#D2A604' />
        {t('subscriptionTools:estimator.equipment.electric_car_distance_small')} <br />
        {t('subscriptionTools:estimator.equipment.electric_car_distance_medium')} <br />
        {t('subscriptionTools:estimator.equipment.electric_car_distance_large')}
      </div>
    </>
  )
}

export default ElectricCarDistance
